import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { TextField, Paper, Autocomplete, CircularProgress } from '@mui/material';
import ApiService from '../../functions/apiService';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';

const CreateTicketModal = (props) => {
    const { addModal, setAddModal } = props;
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('');
    const [imageTwo, setImageTwo] = useState('');
    const inputFile = useRef(null);
    const [employees, setEmployees] = useState([]);
    const [assignTo, setAssignTo] = useState('');
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const loadEmployees = () => {
        setLoading(true);
        ApiService.get('/employee-list-inventory')
            .then(({ data }) => {
                const tempArr = data.data.map((emp) => ({
                    label: `${emp.employee_assignment.EA_Rank} ${emp.First_name} ${emp.Last_name}`,
                    value: emp.Emp_Code,
                    firstname: emp.First_name,
                    lastname: emp.Last_name,
                }));
                setEmployees(tempArr);
                setLoading(false);
            })
            .catch(() => { setLoading(false); });
    };

    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

    const flattenTree = (nodes, options = []) => {
        nodes.forEach((node) => {
            options.push({
                label: capitalize(node.location_description),
                location_id: node.id,
                item_id: '',
                type: node.type,
            });
            node.items?.forEach((it) => {
                options.push({
                    label: capitalize(it.item?.item_description),
                    location_id: it.location_id,
                    item_id: it.id,
                    type: 'item',
                });
            });
            if (node.locations?.length) {
                flattenTree(node.locations, options);
            }
        });
        return options;
    };

    const loadItems = () => {
        ApiService.get('/checklist/all-data')
            .then(({ data }) => {
                setItemOptions(flattenTree(data.data));
            })
            .catch(() => {});
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                if (image === '') {
                    setImage(reader.result);
                } else {
                    setImageTwo(reader.result);
                }
            };
        }
    };

    const resetForm = () => {
        setTitle('');
        setAssignTo('');
        setDescription('');
        setImage('');
        setImageTwo('');
        setSelectedItem(null);
    };

    const onSubmit = async () => {
        setLoading(true);
        const bodyFormData = new FormData();
        bodyFormData.append('location_id', selectedItem?.location_id || '');
        bodyFormData.append('item_id', selectedItem?.item_id || '');
        bodyFormData.append('title', title);
        bodyFormData.append('description', description);
        bodyFormData.append('image', image);
        bodyFormData.append('secondary_image', imageTwo);
        bodyFormData.append('assigned_to', assignTo?.value || '');
        bodyFormData.append('ticket_type', selectedItem?.type || '');
        bodyFormData.append('type', 'base64');
        ApiService.post('/tickets/checklists/generate-inventory-ticket', bodyFormData)
            .then((data) => {
                toast.success(data?.message);
                setLoading(false);
                setAddModal(false);
                resetForm();
            })
            .catch((error) => {
                setLoading(false);
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ));
                } else {
                    toast.error(error?.message);
                }
            });
    };

    useEffect(() => {
        loadEmployees();
        loadItems();
    }, []);

    const itemIconSrc = (type) => {
        if (type === 'location_item') return '/images/location-item.svg';
        if (type === 'location') return '/images/location.svg';
        return '/images/location-blue.svg';
    };

    const itemIconStyle = (type) => {
        const base = type === 'item'
            ? { width: '22px', height: '22px', filter: 'brightness(0) saturate(100%) invert(18%) sepia(84%) saturate(2800%) hue-rotate(343deg) brightness(90%) contrast(96%)' }
            : { width: '18px', height: '18px' };
        return base;
    };

    const itemLabel = selectedItem?.type === 'location_item' ? 'Location + Item'
        : selectedItem?.type === 'location' ? 'Location'
        : selectedItem?.type === 'item' ? 'Item'
        : 'Item / Location';

    return (
        <>
            <Modal show={addModal} size="lg" onHide={() => { setAddModal(false); resetForm(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Ticket</Modal.Title>
                </Modal.Header>
                {loading ?
                    <div style={{ height: 300 }}>
                        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ height: 300 }}>
                            <CircularProgress />
                        </Paper>
                    </div>
                    :
                    <Modal.Body>
                        <Row className='w-100' style={{ flexWrap: 'wrap' }}>

                            {/* Title */}
                            <Col md={6}>
                                <label className='my-1'>Title</label>
                                <TextField
                                    className='mt-1 w-100'
                                    color='secondary'
                                    variant="outlined"
                                    value={title}
                                    placeholder="Enter Title"
                                    sx={{ "& .MuiInputBase-root": { height: '52px', fontSize: "14px" } }}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </Col>

                            {/* Item / Location */}
                            <Col md={6}>
                                <label className='my-1'>{itemLabel}</label>
                                <Autocomplete
                                    options={itemOptions}
                                    value={selectedItem}
                                    onChange={(event, newValue) => setSelectedItem(newValue)}
                                    getOptionLabel={(option) => option?.label || ''}
                                    renderOption={(props, option) => (
                                        <li {...props} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <img src={itemIconSrc(option.type)} style={itemIconStyle(option.type)} />
                                            {option.label}
                                        </li>
                                    )}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: '52px',
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className='mt-1 w-100'
                                            placeholder='Select Item / Location'
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: selectedItem ? (
                                                    <img
                                                        src={itemIconSrc(selectedItem.type)}
                                                        style={{ ...itemIconStyle(selectedItem.type), marginRight: '6px' }}
                                                    />
                                                ) : null,
                                            }}
                                        />
                                    )}
                                />
                            </Col>

                            {/* Assigned To */}
                            <Col md={6}>
                                <label className='mt-3 my-1'>Assign To</label>
                                <Autocomplete
                                    options={employees}
                                    value={assignTo}
                                    onChange={(event, newValue) => { setAssignTo(newValue); }}
                                    getOptionLabel={(option) => option?.label || ''}
                                    renderOption={(props, option) => {
                                        const initials = `${option.firstname?.[0] || ''}${option.lastname?.[0] || ''}`;
                                        return (
                                            <li {...props}>
                                                <span className="red-circle">{initials}</span>
                                                {option.label}
                                            </li>
                                        );
                                    }}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "52px",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: '50px',
                                        }
                                    }}
                                    renderInput={(params) => {
                                        const selectedInitials = assignTo
                                            ? `${assignTo.firstname?.[0] || ''}${assignTo.lastname?.[0] || ''}`
                                            : '';
                                        return (
                                            <TextField
                                                {...params}
                                                className="mt-1 w-100"
                                                placeholder="Assign to"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: assignTo ? (
                                                        <span className="red-circle" style={{ marginLeft: '4px', marginRight: '8px' }}>
                                                            {selectedInitials}
                                                        </span>
                                                    ) : null,
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </Col>

                            {/* Description */}
                            <Col md={12}>
                                <label className='mt-3'>Description</label>
                                <TextField
                                    className='mt-1 w-100'
                                    multiline
                                    color='secondary'
                                    variant="outlined"
                                    value={description}
                                    placeholder="Type message here..."
                                    sx={{
                                        "& .MuiInputBase-root": { minHeight: '87px' },
                                        "& .MuiInputBase-input": { alignSelf: 'flex-start' }
                                    }}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Col>

                            {/* Input Image */}
                            <input
                                type="file"
                                ref={inputFile}
                                style={{ display: 'none' }}
                                accept="image/*"
                                onChange={handleFileChange}
                            />

                            <Col md={12}>
                                <label className='mt-3'>Image</label>
                                <div className='mt-1 w-100 img-box'>
                                    {(image && image !== '') || (imageTwo && imageTwo !== '') ?
                                        <div className='d-flex' style={{ marginRight: 'auto', gap: '12px' }}>
                                            {(image === '' || imageTwo === '') &&
                                                <div onClick={() => inputFile.current.click()}>
                                                    <img src='/images/add-image.png' style={{ width: 70, height: 70, cursor: 'pointer' }} />
                                                </div>
                                            }
                                            {imageTwo && imageTwo !== '' &&
                                                <div style={{ contain: 'content' }}>
                                                    <div className='img-cross' onClick={() => setImageTwo('')}>
                                                        <img src='/images/white-cross.png' style={{ width: 10, height: 10 }} />
                                                    </div>
                                                    <img src={imageTwo} style={{ width: 68, height: 68, borderRadius: 50 }} />
                                                </div>
                                            }
                                            {image && image !== '' &&
                                                <div style={{ contain: 'content' }}>
                                                    <div className='img-cross' onClick={() => setImage('')}>
                                                        <img src='/images/white-cross.png' style={{ width: 10, height: 10 }} />
                                                    </div>
                                                    <img src={image} style={{ width: 68, height: 68, borderRadius: 50 }} />
                                                </div>
                                            }
                                        </div>
                                        :
                                        <>
                                            <span onClick={() => inputFile.current.click()}><img src='/images/camera.png' style={{ width: 40, height: 40, cursor: 'pointer' }} /></span>
                                            <span>Kindly upload your image</span>
                                        </>
                                    }
                                </div>
                            </Col>
                        </Row>

                        <ButtonTheme type='submit' variant="filled" color='primary' width='20%'
                            className='d-flex px-4 mt-4' onClick={() => onSubmit()}>
                            Create
                        </ButtonTheme>
                    </Modal.Body>
                }
            </Modal>
        </>
    );
};

export default CreateTicketModal;
